import { useDraggable } from '@dnd-kit/core'
import { Text } from '@viapeople/components'
import type { ComponentDefinition } from '../store/componentRegistry'

interface ComponentPaletteCardProps {
	component: ComponentDefinition
}

export function ComponentPaletteCard({ component }: ComponentPaletteCardProps) {
	const { attributes, listeners, setNodeRef } = useDraggable({
		id: `palette-${component.id}`,
		data: {
			type: component.name,
			isNew: true,
			component: component,
		},
	})

	return (
		<div
			ref={setNodeRef}
			{...attributes}
			{...listeners}
			className='flex items-center gap-3 py-2 px-3 mb-2 bg-neutral-0 border border-neutral-200 rounded-md cursor-grab hover:border-primary-400 transition-colors'
			draggable='true'>
			<div>{<component.icon />}</div>
			<Text variant='xsmall'>{component.displayName}</Text>
		</div>
	)
}
